import { render } from "./UiCatalog.vue?vue&type=template&id=2fcf79cc&scoped=true"
import script from "./UiCatalog.vue?vue&type=script&lang=js"
export * from "./UiCatalog.vue?vue&type=script&lang=js"

import "./UiCatalog.vue?vue&type=style&index=0&id=2fcf79cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcf79cc"]])

export default __exports__